import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { getAxios } from "src/helpers/index";
import { AppConfigs } from "src/settings";

/** API call for login wit username and password ------------------- **/
export const login = createAsyncThunk("auth/login", async (model, thunkAPi) => {
  try {
    let res = await getAxios().post("Auth", model);
    let res2 = await axios.get(`${AppConfigs.apiBaseUrl}User/Me`, {
      headers: {
        'Authorization': `Bearer ${res?.data?.token}`,
        'Content-Type': 'multipart/form-data'
      }
    })
    localStorage.setItem("userDetails", JSON.stringify({ ...res.data, ...res2.data }));
    localStorage.setItem("loginTime", moment().format());
    return { ...res.data, ...res2.data };
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** API call to retrieve get me data ----------------- **/
export const getMyData = createAsyncThunk("auth/getMyData", async (model, thunkAPi) => {
  try {
    let res = await getAxios().get("User/Me");
    let data = JSON.parse(localStorage.getItem("userDetails"))
    localStorage.setItem('userDetails', JSON.stringify({ ...data, ...res.data }))
    return res.data;
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** API call to check email exists ------------------ **/
export const checkEmailAlreadyExists = createAsyncThunk(
  "auth/exists",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`Auth/exist/${model}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to retrieve lookup values based on type ----------------------- **/
export const getLookup = createAsyncThunk(
  "auth/getLookup",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`/Lookup/${model?.type}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

export const isSignoutModalOpen = createAction(
  "auth/isSignoutModalOpen",
  (model) => {
    return { payload: model };
  }
);

/** API call to send OTP ------------------- **/
export const sendEmailOtp = createAsyncThunk(
  "auth/sendEmailOtp",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`/Auth/sendotp?email=${model?.email}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to verify entered OTP -------------------- **/
export const VerifyOtp = createAsyncThunk(
  "auth/VerifyOtp ",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().post(`/Auth/confirmotp`, model);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call change password ------------- **/
export const ChangePassword = createAsyncThunk(
  "auth/VerifyOtp ",
  async (model, thunkAPi) => {
    try {
      await getAxios().post(`/Auth/forgotpassword`, model);
      return true;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);
